import Vue from 'vue';
import Buefy from 'buefy';
import '@mdi/font/css/materialdesignicons.css';
import './style.scss';

Vue.use(Buefy, {
  defaultInputHasCounter: false,
  defaultTabsAnimated: false,
});
